<div class="aza-cart-v2-order-items-card-row aza-horizontal-stack">
    <div class="aza-cart-v2-order-items-card-row-label">
        <ng-content select="[aza-cart-v2-order-items-card-row-label]"></ng-content>
    </div>
    <div class="aza-cart-v2-order-items-card-row-value">
        <ng-content select="[aza-cart-v2-order-items-card-row-value]"></ng-content>
    </div>
</div>
